import axios from '@/util/axios';

// 获取首页所有task 列表
export const downloadManual = (params) => {
  const requestURL = '/e2estservice/upload/preview';
  const { fileS3Url } = params;
  if (!fileS3Url) {
    this.$message.error('缺少请求参数');
    return;
  }
  return axios({
    url: `${requestURL}?fileS3Url=${fileS3Url}`,
    method: 'post',
    responseType: 'arraybuffer'
  });
};

// 获取用户手册信息
export const getManualInfo = (params) => {
  const requestURL = '/e2estservice/sys/file/queryByType';
  return axios.get(requestURL, { params });
};



// WEBPACK FOOTER //
// ./src/api/home/manual.js